import { createAction, props } from '@ngrx/store';
import { MetadataKind } from '../../../metadata-mgmt/models/Metadata-mgmt';
import {
  ICrossFieldRuleCreate,
  ICrossFieldRulePatch,
  IRuleFilters,
  IRuleParamDefinitionCreate,
  IRuleParamDefinitionPatch,
  IRuleTypeDefinitionPayload,
  IValidatorRuleCreate,
  IValidatorRulePatch,
} from '../../models/validation-rule';

enum ValidationRulesUiActionTypes {
  LoadFieldRules = '[Validation Rules UI] Load Field Rules',
  LoadCrossFieldRules = '[Validation Rules UI] Load Cross-Field Rules',
  LoadCatalog = '[Validation Rules UI] Load Catalog',

  CreateFieldRule = '[Validation Rules UI] Create Field Rule',
  PatchFieldRule = '[Validation Rules UI] Patch Field Rule',
  DeleteFieldRule = '[Validation Rules UI] Delete Field Rule',

  CreateCrossFieldRule = '[Validation Rules UI] Create Cross-Field Rule',
  PatchCrossFieldRule = '[Validation Rules UI] Patch Cross-Field Rule',
  DeleteCrossFieldRule = '[Validation Rules UI] Delete Cross-Field Rule',

  SelectSourceType = '[Validation Rules UI] Select Source Type',
  SelectTemplate = '[Validation Rules UI] Select Template',
  SelectKind = '[Validation Rules UI] Select Kind',

  // Configurable catalog actions
  LoadOperations = '[Validation Rules UI] Load Operations',
  LoadRuleTypeDefinitions = '[Validation Rules UI] Load Rule Type Definitions',
  CreateRuleTypeDefinition = '[Validation Rules UI] Create Rule Type Definition',
  PatchRuleTypeDefinition = '[Validation Rules UI] Patch Rule Type Definition',
  DeleteRuleTypeDefinition = '[Validation Rules UI] Delete Rule Type Definition',

  CreateParamDefinition = '[Validation Rules UI] Create Param Definition',
  PatchParamDefinition = '[Validation Rules UI] Patch Param Definition',
  DeleteParamDefinition = '[Validation Rules UI] Delete Param Definition',
}

export const LoadFieldRules = createAction(
  ValidationRulesUiActionTypes.LoadFieldRules,
  props<{ filters: IRuleFilters }>(),
);

export const LoadCrossFieldRules = createAction(
  ValidationRulesUiActionTypes.LoadCrossFieldRules,
  props<{ filters: IRuleFilters }>(),
);

export const LoadCatalog = createAction(ValidationRulesUiActionTypes.LoadCatalog);

export const CreateFieldRule = createAction(
  ValidationRulesUiActionTypes.CreateFieldRule,
  props<{ payload: IValidatorRuleCreate }>(),
);

export const PatchFieldRule = createAction(
  ValidationRulesUiActionTypes.PatchFieldRule,
  props<{ id: number; changes: IValidatorRulePatch }>(),
);

export const DeleteFieldRule = createAction(
  ValidationRulesUiActionTypes.DeleteFieldRule,
  props<{ id: number }>(),
);

export const CreateCrossFieldRule = createAction(
  ValidationRulesUiActionTypes.CreateCrossFieldRule,
  props<{ payload: ICrossFieldRuleCreate }>(),
);

export const PatchCrossFieldRule = createAction(
  ValidationRulesUiActionTypes.PatchCrossFieldRule,
  props<{ id: number; changes: ICrossFieldRulePatch }>(),
);

export const DeleteCrossFieldRule = createAction(
  ValidationRulesUiActionTypes.DeleteCrossFieldRule,
  props<{ id: number }>(),
);

export const SelectSourceType = createAction(
  ValidationRulesUiActionTypes.SelectSourceType,
  // null = Core scope (templates with source_type=null)
  props<{ sourceTypeId: number | null }>(),
);

export const SelectTemplate = createAction(
  ValidationRulesUiActionTypes.SelectTemplate,
  props<{ templateId: number | null }>(),
);

export const SelectKind = createAction(
  ValidationRulesUiActionTypes.SelectKind,
  // BASELINE (pre-promotion) vs POST_ANALYSIS templates/rules.
  props<{ kind: MetadataKind }>(),
);

// ---- Configurable catalog -------------------------------------------

export const LoadOperations = createAction(ValidationRulesUiActionTypes.LoadOperations);

export const LoadRuleTypeDefinitions = createAction(
  ValidationRulesUiActionTypes.LoadRuleTypeDefinitions,
);

export const CreateRuleTypeDefinition = createAction(
  ValidationRulesUiActionTypes.CreateRuleTypeDefinition,
  props<{ payload: IRuleTypeDefinitionPayload & { code: string } }>(),
);

export const PatchRuleTypeDefinition = createAction(
  ValidationRulesUiActionTypes.PatchRuleTypeDefinition,
  props<{ id: number; changes: Partial<IRuleTypeDefinitionPayload> }>(),
);

export const DeleteRuleTypeDefinition = createAction(
  ValidationRulesUiActionTypes.DeleteRuleTypeDefinition,
  props<{ id: number }>(),
);

export const CreateParamDefinition = createAction(
  ValidationRulesUiActionTypes.CreateParamDefinition,
  props<{ payload: IRuleParamDefinitionCreate }>(),
);

export const PatchParamDefinition = createAction(
  ValidationRulesUiActionTypes.PatchParamDefinition,
  props<{ id: number; changes: IRuleParamDefinitionPatch }>(),
);

export const DeleteParamDefinition = createAction(
  ValidationRulesUiActionTypes.DeleteParamDefinition,
  props<{ id: number }>(),
);
